import { collection, query, where, getDocs, doc, getDoc, updateDoc, deleteField } from 'firebase/firestore';
import { db } from '../firebase-config';

// Prüft, ob ein Benutzer bereits in einer Lobby ist und entfernt ihn gegebenenfalls
export const leaveCurrentLobby = async (userId, excludeLobbyId = null) => {
  try {
    // Suche nach allen Lobbys, in denen der Benutzer ist
    const sessionsRef = collection(db, 'game_sessions');
    const q = query(sessionsRef, where(`players.${userId}`, '!=', null));
    const querySnapshot = await getDocs(q);

    // Gehe durch alle gefundenen Lobbys
    for (const docSnapshot of querySnapshot.docs) {
      // Überspringe die aktuelle Lobby
      if (excludeLobbyId && docSnapshot.id === excludeLobbyId) continue;

      const sessionRef = doc(db, 'game_sessions', docSnapshot.id);
      const sessionDoc = await getDoc(sessionRef);
      
      if (sessionDoc.exists()) {
        const sessionData = sessionDoc.data();
        const players = { ...sessionData.players };
        delete players[userId];
        
        // Wenn keine Spieler mehr übrig sind, setze den Status auf 'finished'
        if (Object.keys(players).length === 0) {
          await updateDoc(sessionRef, {
            [`players.${userId}`]: deleteField(),
            status: 'finished',
            lastActivity: new Date()
          });
        } else if (sessionData.gameMasterId === userId) {
          // Wenn der Benutzer der Game Master ist, übertrage die Rolle an einen anderen Spieler
          const nextPlayerId = Object.keys(players)[0];
          await updateDoc(sessionRef, {
            [`players.${userId}`]: deleteField(),
            gameMasterId: nextPlayerId,
            [`players.${nextPlayerId}.isGameMaster`]: true,
            lastActivity: new Date()
          });
        } else {
          // Entferne nur den Spieler
          await updateDoc(sessionRef, {
            [`players.${userId}`]: deleteField(),
            lastActivity: new Date()
          });
        }
      }
    }
  } catch (error) {
    console.error('Error leaving current lobby:', error);
  }
}; 